import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import GamesUsersTable from './GamesUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';

/**
 * Company Games → Employees / Members.
 *
 * Engagement only, and no row opens anything. See GamesUsersTable for what is
 * deliberately absent from it.
 */
const CGamesUsers = () => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Games | Shoorah</title>
      </Helmet>
      <GamesUsersTable
        key={`${isB2BFansMode}-${department}`}
        tableName="company-games-users"
        department={department}
      />
    </div>
  );
};

export default CGamesUsers;
